import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Form, Button, message } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields, formFields1, formFields2, formFields3 } from './formField';
import { FormField, RadioGroup } from 'components';
import { get, omit, moment } from 'lodash';
import { getProjectPlanInfo, updateFormField, validateIndividualIncome } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Cancel } from 'assets/icons/cancel_icon.svg';
import { formattedNumber, isAuditor, isBeneficiary, isInvestor, validAFM} from 'utils';
import { Upload } from 'components';
import Sorefsis from 'components/sorefsis';
import SorefsisChart from 'components/layout/components/sorefsisChart';
import { DownloadedItems } from '../documentsBeneficiary/components';
import { flattenDocs } from '../documentsBeneficiary/utils';
import { IncomeValidationField } from './components';

const EvaluationBeneficiary = () => {
  const task = useSelector(state => state.forms.task);
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isAuditor(user?.groups) || task.taskName !== 'task.name.application_evaluation_by_auditor';
  const carrier = useSelector(state => state.forms.carrier);
  const docs = useSelector(state => state.forms.documents);
  const flatDocs = flattenDocs(docs);
  const audit = useSelector(state => state.forms.audit);
  const individualIncomeValidation = useSelector(state => state.forms.individualIncomeValidation);
  const totalAmountSorefsis = useSelector(
    state => state.forms.carrier.totalAmountSorefsis
  );
  const dispatch = useDispatch();

  const sorefsisVat = carrier?.ownerStatus === 'ownerStatusOwner' ?
                      carrier?.legalVat :
                      carrier?.ownerVat;
  const mainKad = 100; //default kad

  useEffect (() => {
    if (validAFM(sorefsisVat)) {
      dispatch(getProjectPlanInfo(sorefsisVat, mainKad));
      // Income validation is now handled by the IncomeValidationField component
    }
  },[sorefsisVat])

  useEffect(() => {
    form.setFieldsValue({
    ameaMember: carrier.ameaMember,
    powerSupply: carrier.powerSupply,
    powerSupplyPrivate: carrier.powerSupplyPrivate,
    powerSupplyPublic: carrier.powerSupplyPublic,
    legalChildren: carrier.legalChildren,
    commentAud: audit.commentAud,
    otherReasonAud: audit.otherReasonAud,
    ameaMemberAud: audit.ameaMemberAud,
    powerSupplyAud: audit.powerSupplyAud,
    powerSupplyPrivateAud: audit.powerSupplyPrivateAud,
    powerSupplyPublicAud: audit.powerSupplyPublicAud,
    legalChildrenAud: audit.legalChildrenAud,
    vulnerableHousehold: audit.vulnerableHousehold,
    //vulnerableHouseholdAud: audit.vulnerableHouseholdAud,
    preApprovalAud: audit.preApprovalAud,
    preRejectAud: audit.preRejectAud,
    preReturnAud: audit.preReturnAud,
    });
  }, [form, carrier, audit]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'select' || type === 'number' || type === 'switch') {
      newValue = event;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    }

    dispatch(
      updateFormField({
        group: 'audit',
        key,
        value: newValue,
      })
    );
  };

  const renderFieldValue = field => {
    const value = get(audit, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  // Just add error handling to the original formFields approach
  const updatedFormFields = formFields.map(field => {
    if (field.name === 'vulnerableHousehold') {
      return {
        ...field,
        placeholder: individualIncomeValidation.loading 
          ? 'Επικύρωση εισοδήματος...' 
          : field.placeholder || '',
        // Add validation status for error display
        validateStatus: individualIncomeValidation.loading ? 'validating' :
                       individualIncomeValidation.error ? 'error' : '',
        help: individualIncomeValidation.error ? 'Σφάλμα επικύρωσης' : ''
      };
    }
    return field;
  });

  return (
    <div>
      <Form
        form={form}
        initialValues={{...audit }}
        // trigger="onChange"
      >
        <div
          className=""
          style={{ width: '55%', display: 'inline-block' }}
        >
        <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
        Αξιολόγηση Αίτησης 
        </p>
        
        {/* Show income validation status */}
        {individualIncomeValidation.error && (
          <div style={{ color: 'red', marginBottom: '16px' }}>
            Σφάλμα επικύρωσης εισοδήματος: {individualIncomeValidation.error}
          </div>
        )}
        
        <Row >
        {updatedFormFields.map((field, index) => {
            return (
              field.type !== 'empty' ? (
              <Col key={index} className="gutter-row" span={field.span}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  className="ml-5"
                  validateStatus={field.validateStatus}
                  help={field.help}
                >
                  {field.name === 'vulnerableHousehold' ? (
                    <>
                      <div className="ant-form-item-label">
                        <label title={field.label}>
                          {field.label}
                        </label>
                      </div>
                      <IncomeValidationField
                        form={form}
                        fieldName="vulnerableHousehold"
                        disabled={true}
                        viewMode={viewMode}
                      />
                    </>
                  ) : (
                    <FormField
                      key={index}
                      disabled={!viewMode && field.name.includes("Aud") ? false : true}
                      style={
                        viewMode
                          ? { pointerEvents: "none", cursor: "not-allowed" }
                          :
                          field.name.includes("Aud") ?
                          {marginLeft: '0.5rem'}
                          : {}
                      }
                      className={`${viewMode ? "custom-checkbox-disabled" : ""}`}
                      {...omit(field, ["span", "rules", "validateStatus", "help"])}
                      onChange={(value) =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  )}
                </Form.Item>
              </Col>
            )
            : (
              <Col key={index} span={field.span} /> // Spacer
            ))
        })}
        </Row>
        </div>
        <div
          className=""
          style={{ width: '45%', display: 'inline-block'}}
        >
        <Row>
        {formFields2.map((field, index) => {
          return (
            <Col key={index} className="gutter-row" span={field.span}>
              <Form.Item
                name={[field.name]}
                rules={field.rules}
                value={renderFieldValue(field)}
              >
                <FormField
                  key={index}
                  disabled={viewMode}
                  style={
                    viewMode 
                    ? { pointerEvents: 'none', cursor: 'not-allowed' } 
                    : {}
                  }
                  className={viewMode ? 'custom-checkbox-disabled' : ''}
                  {...omit(field, ['span', 'rules'])}
                  onChange={value =>
                    handleChange({
                      key: field.name,
                      type: field.type,
                      event: value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          );
        })}
        </Row>
        </div>
        <div className='mt-1' style={{ width: '45%', display: 'inline-block' }}>
          {!viewMode ? formFields3.map((item, index) => {
            return (
              <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
            );
          })
        : 
          <div className='mt-2'>
              <DownloadedItems content={formFields3} docs={flatDocs} />
          </div>
        }
        </div>
        
        <Row
        gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
        className="carrier-data-form__row mt-6 sorefsis"
      >
        <Col span={20} className="sorefsis-col-1">
          <>
            <Sorefsis viewMode={viewMode}/>
          </>
        </Col>
        <Col span={4} className="sorefsis-col-2">
          <div className="mt-1">
            <SorefsisChart
              realValue={totalAmountSorefsis ? totalAmountSorefsis : 0}
              limit={process.env.REACT_APP_SOREFSIS_AMOUNT }
            />
          </div>
          <div>
            {!viewMode && totalAmountSorefsis > (process.env.REACT_APP_SOREFSIS_AMOUNT) && (
              <div
                role="alert"
                className="ant-form-item-explain-error mt-0 mb-2"
              >
                Το Σύνολο Σώρευσης έχει υπερβεί το Όριο Deminimis κατά{' '}
                {formattedNumber(totalAmountSorefsis - (process.env.REACT_APP_SOREFSIS_AMOUNT))}€
              </div>
            )}
          </div>
        </Col>
      </Row>
      </Form>
    </div>
  );
};

export default EvaluationBeneficiary;